import React from 'react';
import useDialog from '../../hooks/useDialog';
import { useTranslation } from 'react-i18next';

const VideoChatBubble = (props) => {
  const { showDialog, hideDialog } = useDialog();
  const { content, userInfo, isOwn, timestamp, isBlocked } = props.item;
  const { t } = useTranslation();

  const confirmReport = () => {
    showDialog({
      dialogType: 'ConfirmDialog',
      dialogProps: {
        title: t('report_confirm_msg'),
        confirmText: t('confirm'),
        cancelText: t('cancel'),
        handleConfirm: () => {
          props.onReport(timestamp, userInfo?.userNo);
        },
        handleClose: () => {},
      },
    });
  };

  const confirmRemove = () => {
    showDialog({
      dialogType: 'ConfirmDialog',
      dialogProps: {
        title: t('delete_confirm_msg'),
        confirmText: t('confirm'),
        cancelText: t('cancel'),
        handleConfirm: () => {
          props.onDelete(timestamp);
          hideDialog();
        },
        handleClose: () => {},
      },
    });
  };

  return (
    <>
      {/* 신고로 블락된 메세지 숨김 처리 */}
      {!isBlocked ? (
        <div className={'video-chat-bubble'}>
          <div className={'video-chat-top-group'}>
            <div className='video-chat-name-group'>
              {/* 본인인 경우 is-me class biding */}
              <p className={`video-chat-name text-ellipsis ${isOwn ? 'is-me' : ''}`}>{userInfo?.userName}</p>
            </div>
            <div className='video-chat-button-group'>
              {/* 본인인 경우 삭제 버튼 노출 */}
              {isOwn ? (
                <button
                  type={'button'}
                  className={'button-default chat-del-button'}
                  aria-label={'Delete'}
                  onClick={() => {
                    confirmRemove();
                  }}
                >
                  <i className={'icon icon-close-gray'} />
                </button>
              ) : null}
              {/* 본인이 아닌 경우 신고 버튼 노출 */}
              {!isOwn ? (
                <button
                  type={'button'}
                  className={'button-default report-button'}
                  aria-label={'Report'}
                  onClick={() => {
                    confirmReport();
                  }}
                >
                  {t('report')}
                </button>
              ) : null}
            </div>
          </div>
          <div className='video-chat-msg-group'>
            <p className={'video-chat-msg'}>{content}</p>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default VideoChatBubble;
